
const state = () => ({
  productStock: [],
  lowStockThreshold: 0,
  products: [],
  taxonomies: {},
  filters: {
    dietary: [],
    wine_type: [],
    sweetness: [0, 5],
    brand: [],
    varietal: [],
    collection: [],
    region: [],
    price: []
  },
  sorters: '',
  sortDir: 'ASC',
  view: false
})

const mutations = {
  UPDATE_CATALOGUE_VIEW_MODE: function(state, mode) {
    state.view = mode
  },
  UPDATE_CATALOG_VIEW_FILTER: function(state, filterValues) {
    state.filters = filterValues
  },
  UPDATE_CATALOG_VIEW_SORTER: function(state, sorterValue) {
    state.sorters = sorterValue
  },
  UPDATE_CATALOG_VIEW_SORT_DIRECTION: function(state, sortDirValue) {
    state.sortDir = sortDirValue
  },
  SET_PRODUCTS: function(state, productList) {
    state.products = productList
  },
  SET_PRODUCTS_STOCK: function(state, payload) {
    state.productStock = payload.stock
  },
  SET_LOW_STOCK_THRESHOLD: function(state, payload) {
    state.lowStockThreshold = payload
  },
  STORE_TAXONOMIES: function(state, payload) {
    state.taxonomies = payload
  }
}

const actions = {
  setCatalogView: function({ commit, state }, payload) {
    commit('UPDATE_CATALOGUE_VIEW_MODE', payload)
  },
  setCatalogFilters: function({ commit, state }, payload) {
    commit('UPDATE_CATALOG_VIEW_FILTER', payload)
  },
  setCatalogSorter: function({ commit, state }, payload) {
    commit('UPDATE_CATALOG_VIEW_SORTER', payload)
  },
  setCatalogSortDirection: function({ commit, state }, payload) {
    commit('UPDATE_CATALOG_VIEW_SORT_DIRECTION', payload)
  },
  setProducts: function({ commit, state }, payload) {
    commit('SET_PRODUCTS', payload)
  },
  loadLowStockThreshold: function({ commit, rootGetters }) {
    commit('SET_LOW_STOCK_THRESHOLD', rootGetters.getModuleSetting('wine-catalog', 'low-stock-threshold', 0))
  },
  loadProductStock: function({ commit, rootGetters, rootState }) {
    const uri = rootGetters.getServiceEndpoint('datastore').concat(rootState.registry.getServiceSetting('inventory', 'stock'))
    const options = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      redirect: 'follow',
      credentials: 'omit'
    }
    return fetch(uri, options)
      .then(resp => {
        if (resp) {
          return resp.json()
        }
        throw new Error('No REST Response or Invalid REST Response')
      })
      .then(resp => {
        if (resp.data && resp.status) {
          commit('SET_PRODUCTS_STOCK', { timestamp: resp.timestamp, stock: resp.data })
        }
        else {
          throw new Error('Error Loading All Products Stock.')
        }
      })
  },
  storeTaxonomies: function({ commit }, payload) {
    commit('STORE_TAXONOMIES', payload)
  }
}

const getters = {
  loaded: function(state) {
    return true
  },
  viewMode(state, _getters, _rootState, rootGetters) {
    return state.view !== false ? state.view : rootGetters['getModuleSetting']('wine-catalog', 'view-mode', 'grid-view')
  },
  getProductStock: function(state) {
    return state.productStock
  },
  getLowStockThreshold: function(state) {
    return state.lowStockThreshold
  },
  getProducts: function(state) {
    return state.products
  },
  getTaxonomies: function(state) {
    return state.taxonomies
  },
  getTaxonomy: (state) => payload => {
    return state.taxonomies[payload] || null
  }
}

// Create the vuex store
export default {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
}
